import { WebLayout } from 'components/Layout';
import React, { useEffect } from 'react';

export const Terms = () => {
  useEffect(() => {
    window.scroll(0, 0);
  }, []);
  return (
    <WebLayout
      title="Terms & Conditions"
      description="Terms and conditions that govern your use of dejunk"
    >
      <div className="max-w-4xl mx-auto px-4 py-10">
        <h1 class="text-3xl font-bold mb-6">Terms & Conditions</h1>
        <p class="text-sm text-gray-500 mb-8">Last updated: 4th June, 2026</p>

        <section class="mb-8">
          <p class="text-gray-700">
            Welcome to Dejunk. These Terms and Conditions govern your use of our platform. By
            accessing or using Dejunk, you agree to comply with and be bound by these terms.
          </p>
        </section>

        <section class="mb-8">
          <h2 class="text-xl font-semibold mb-3">1. Use of the Service</h2>
          <p class="text-gray-700">
            Dejunk is a location-based marketplace that allows users to post items and connect
            directly with nearby buyers via phone. You agree to use the platform only for lawful
            purposes.
          </p>
        </section>

        <section class="mb-8">
          <h2 class="text-xl font-semibold mb-3">2. User Accounts</h2>
          <ul class="list-disc ml-6 text-gray-700 space-y-2">
            <li>To create an account on dejunk you must be 18 years and above. </li>
            <li>You must provide accurate and complete information.</li>
            <li>You are responsible for maintaining the security of your account.</li>
            <li>Your phone number may be visible on your listings.</li>
          </ul>
        </section>

        <section class="mb-8">
          <h2 class="text-xl font-semibold mb-3">3. Posting Items</h2>
          <ul class="list-disc ml-6 text-gray-700 space-y-2">
            <li>
              All listings must be accurate and not misleading. If you provide misleading
              information, your account will be blocked and may result in legal action.
            </li>
            <li>
              You must own or have the right to sell or give away the item. Posting items that do
              not belong to you may result in legal action.
            </li>
            <li>Prohibited items include illegal goods, hazardous materials, and stolen items.</li>
          </ul>
        </section>

        <section class="mb-8">
          <h2 class="text-xl font-semibold mb-3">4. Payments</h2>
          <p class="text-gray-700">
            A posting fee may be required before your item becomes visible. Payments are
            non-refundable once a listing has been published.
          </p>
        </section>

        <section class="mb-8">
          <h2 class="text-xl font-semibold mb-3">5. User Interactions</h2>
          <p class="text-gray-700">
            Dejunk does not facilitate transactions directly. Users communicate via phone call or
            whatsapp and are solely responsible for their interactions, negotiations, and exchanges.
          </p>
        </section>

        <section class="mb-8">
          <h2 class="text-xl font-semibold mb-3">6. Limitation of Liability</h2>
          <p class="text-gray-700">
            Dejunk is not responsible for any damages, losses, or disputes arising from user
            interactions, transactions, or listings on the platform.
          </p>
        </section>

        <section class="mb-8">
          <h2 class="text-xl font-semibold mb-3">7. Content Ownership</h2>
          <p class="text-gray-700">
            By posting content, you grant Dejunk a non-exclusive license to display and distribute
            your listings within the platform and Dejunk's social media accounts to widen your
            chances of getting buyers.
          </p>
        </section>

        <section class="mb-8">
          <h2 class="text-xl font-semibold mb-3">8. Termination</h2>
          <p class="text-gray-700">
            We reserve the right to suspend or terminate accounts that violate these terms or misuse
            the platform.
          </p>
        </section>

        <section class="mb-8">
          <h2 class="text-xl font-semibold mb-3">9. Changes to Terms</h2>
          <p class="text-gray-700">
            We may update these Terms at any time. Continued use of the platform constitutes
            acceptance of the updated terms.
          </p>
        </section>

        <section class="mb-8">
          <h2 class="text-xl font-semibold mb-3">10. Contact Us</h2>
          <p class="text-gray-700">
            If you have any questions about these Terms, please contact us at:
            <br />
            <a href="mailto:ashitacreatives@gmail.com" class="font-medium text-green-600 underline">
              ashitacreatives@gmail.com
            </a>{' '}
            or{' '}
            <a href="tel:+256782692271" class="font-medium text-green-600 underline">
              (+256) 782 692271
            </a>
          </p>
        </section>
      </div>
    </WebLayout>
  );
};
